import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Container, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import CustomerGroupsFormContentView from './Includes/CustomerGroupsFormContentView'
import { addCustomerGroup } from 'utlis/Apis/Customers_API'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    CUSTOMERGROUP_ADDED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_CUSTOMERGROUP,
} from 'utlis/AppMessages/AppMessages'
import { createFormValidationSchema, initialCreateFormValues } from './FormHelper'

function CreateCustomerGroup(props) {
    const submitButtonRef = useRef(null)
    const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)

    //const [emailEvents, setEmailEvents] = useState([])

    // on page load
    /*
    useEffect(() => {
        // getting event id
        getEmailEvents(props.currentUser.userToken).then(res => {
            const emailEvents = res.data

            // if request is success
            if (emailEvents.success) {
                setEmailEvents(emailEvents.data.data)
            }

            // if request is not succeed
            if (emailEvents.error) {
                console.log('Error occured while loading email events!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })

        return () => {
            // canceling admin users api when user leaves the component
            cancelGetEmailEventsApi()
        }
    }, [])
    */

    const onCreateFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setCreateButtonDisable(true)
            setCreateButtonLoading(true)
            addCustomerGroup(props.currentUser.userToken, values).then(res => {
                setGlobalLoading(false)

                const addingCustomerGroup = res.data
                if (addingCustomerGroup.success) {
                    setCreateButtonLoading(false)
                    window.scrollTo(0, 0)
                    props.history.push('/customers/groups', {
                        shouldReload: true
                    })
                    formik.resetForm()
                    toast.dismiss();
                    toast.success(CUSTOMERGROUP_ADDED_SUCCESSFULLY, {
                        autoClose: 2000,
                        onClose: () => {

                        }
                    })
                }
                if (addingCustomerGroup.error) {
                    console.log(ERROR_WHILE_CREATING_CUSTOMERGROUP, res)
                    setCreateButtonDisable(false)
                    setCreateButtonLoading(false)
                    toast.dismiss();
                    toast.error(ERROR_WHILE_CREATING_CUSTOMERGROUP, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setGlobalLoading(false)
                        setCreateButtonDisable(false)
                        setCreateButtonLoading(false)
                    }
                })
            })
        }
    }

    const formik = useFormik({
        initialValues: initialCreateFormValues,
        validationSchema: createFormValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    const getHTML_editorResult = (data) => {
        formik.setFieldValue("customergroupDescription", data)
    }

    return (
        <section id="app-Status__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-Status__create-details">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Create Customer Group</p>
                        <p className="app-desc">
                        </p>
                    </div>
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <CustomerGroupsFormContentView
                                formik={formik}
                                getHTML_editorResult={getHTML_editorResult}
                            />
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to="/customers/groups" className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={createButtonDisable}
                                        onClick={handleFormSubmission}>
                                        {
                                            createButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Create Customer Group</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateCustomerGroup)